import React, { ReactElement, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import {
    useEditMessageMutation,
} from "../../../__generated__/api";
import Confirm from "../../confirm/Confirm";
import Editor, { EditorInstance } from "../../editor/Editor";
import Styles from "../Chat.module.scss";
import useChatState from "../chat-state";

export function EditMessage({
    ticketMessageId, text,
} : {
    text: string | undefined;
    ticketMessageId: string | undefined
}):ReactElement {
    const [body, setBody] = useState(text);

    const [editMessage] = useEditMessageMutation();
    const editorRef = React.createRef<EditorInstance>();
    const chatState = useChatState();
    useEffect(() => {
        setBody(text);
        if (ticketMessageId) {
            setTimeout(() => {
                editorRef?.current?.focusEnd();
            }, 100);
        } else {
            chatState.setEditingMessageId?.(undefined);
        }
    }, [ticketMessageId]);

    const onSave = async () => {
        await editMessage({
            variables: {
                ticketMessageId,
                message: {
                    body,
                },
            },
        });
        chatState.setEditingMessageId?.(undefined);
    };

    return (
        <Confirm
            shouldShow={ticketMessageId != null}
            onConfirm={onSave}
            size="lg"
            confirmText="Confirm"
            onHide={() => chatState.setEditingMessageId?.(undefined)}
            dialogClassName="mt-5"
        >

            <div>

                <Editor
                    ref={editorRef}
                    onChange={change => setBody(change)}
                    text={body}
                    className={`border ${Styles.editor}`}
                    shouldAllowAttachments={false}
                />

            </div>

        </Confirm>
    );
}

export default function EditMessageAction({ ticketMessageId }: {
    ticketMessageId: string;
}): ReactElement {
    const state = useChatState();
    return (
        <Dropdown.Item onClick={() => state.setEditingMessageId?.(ticketMessageId)} className="text-white">
            Edit Message
        </Dropdown.Item>
    );
}
